import script from "./EmailVerifyPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmailVerifyPage.vue?vue&type=script&setup=true&lang=ts"

import "./EmailVerifyPage.vue?vue&type=style&index=0&id=83f0a1b2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83f0a1b2"]])

export default __exports__